<template>
  <div>
    <div class="sug_public_list" v-show="list.length !== 0">
      <div class="sug_list_title">公开</div>
      <ul id="sugPublicList" class="sug_list_ul">
        <li v-for="item in list" v-show="item.url && item.title">
          <a
            target="_blank"
            :href="item.url"
            :title="inputWordsReplaceFn(item.title, 7)"
            v-html="item.title"
          ></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { inputWordsReplaceFn } from '@/utils/utils'
export default {
  name: 'SugPublic',
  props: ['list'],
  data() {
    return {}
  },
  methods: { inputWordsReplaceFn }
}
</script>

<style lang="less"></style>
